import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Allroutes from './routes/Allroutes';

const App = () => (
  <BrowserRouter>
    <Allroutes />
  </BrowserRouter>
);

export default App;
